import axios from "axios"
export function deleteAdvertisementCampaignAdmin(token, advertiserId) {
    return axios.get(process.env.REACT_APP_API_URL + `/deleteAdvertisementAdmin?advertisementId=${advertiserId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}